import { Close } from "@mui/icons-material";
import { styled, Typography, Grid, IconButton } from "@mui/material";
// @ts-ignore
import ChequeIcon from "assets/icons/chequeDrawer/ChequeIcon";
import FolderIcon from "assets/icons/chequeDrawer/FolderIcon";
import TransferIcon from "assets/icons/chequeDrawer/TransferIcon";
import { useDispatch, useSelector } from "react-redux";
import { addOpenDrawer } from "store/actions/appAction";

const HeaderContainer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "64px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "12px 16px",
}));
const HeaderRightItem = styled("div")(({ theme }) => ({
  width: "140px",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));
const HeaderLeftItem = styled("div")(({ theme }) => ({
  width: "70px",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const Tag = styled("div")(({ theme }) => ({
  minWidth: "70px",
  padding: "0 8px",
  height: "28px",
  display: "flex",
  alignItems: "center",
  backgroundColor: "#EBF3FC",
  borderColor: "#8CA6C9",
  borderRadius: "4px",
  borderWidth: "1px",
  borderStyle: "solid",
  justifyContent: "center",
}));

export const FormContainer = styled(Grid)(({ theme }) => ({
  padding: "20px 16px",
}));

export const HeaderComponent = () => {
  const anchor = useSelector((state: any) => state.appReducer.anchor);
  const dispatch = useDispatch();

  return (
    <HeaderContainer>
      <HeaderRightItem>
        <ChequeIcon />
        <Typography>جزئیات چک</Typography>
      </HeaderRightItem>
      <HeaderLeftItem>
        {/* <TransferIcon />
        <FolderIcon /> */}
        <IconButton
          aria-label="delete"
          onClick={() => {
            dispatch(addOpenDrawer(false, undefined, anchor));
          }}
        >
          <Close className="text-base" style={{ height: "24px", width: "24px" }} />
        </IconButton>
      </HeaderLeftItem>
    </HeaderContainer>
  );
};
